module.exports = __webpack_public_path__ + "static/img/swiper_bg.0d7ba0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/swiper_bg.png
// module id = vLIN
// module chunks = 0